import { render, staticRenderFns } from "./UnsubscribeBridge.vue?vue&type=template&id=54def4e9&scoped=true"
import script from "./UnsubscribeBridge.vue?vue&type=script&lang=js"
export * from "./UnsubscribeBridge.vue?vue&type=script&lang=js"
import style0 from "./UnsubscribeBridge.vue?vue&type=style&index=0&id=54def4e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54def4e9",
  null
  
)

export default component.exports